<template>
  <!-- Plug icon -->
  <svg v-if="props.typeOfIcon === 'power-plug' && !large" class="icon-small" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      id="plug-circle-small_black"
      stroke="#363433"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M10 8v3m4-3v3m-2 10v-5m0 5a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM8 11h8v1.8c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C14.48 16 13.92 16 12.8 16h-1.6c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C8 14.48 8 13.92 8 12.8V11Z" />
  </svg>

  <svg v-if="props.typeOfIcon === 'power-plug' && large" class="icon-large" xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
    <path
      id="plug-circle-large_black"
      stroke="#363433"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="4"
      d="M25 20v7.5M35 20v7.5m-5 25V40m0 12.5c12.426 0 22.5-10.074 22.5-22.5S42.426 7.5 30 7.5 7.5 17.574 7.5 30 17.574 52.5 30 52.5Zm-10-25h20V32c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185C36.2 40 34.8 40 32 40h-4c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C20 36.2 20 34.8 20 32v-4.5Z" />
  </svg>

  <!-- File icon -->
  <svg v-if="props.typeOfIcon === 'document' && !large" class="icon-small" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      id="file-small_black"
      d="M9 17H15M9 13H15M9 9H10M13 3H8.2C7.0799 3 6.51984 3 6.09202 3.21799C5.71569 3.40973 5.40973 3.71569 5.21799 4.09202C5 4.51984 5 5.0799 5 6.2V17.8C5 18.9201 5 19.4802 5.21799 19.908C5.40973 20.2843 5.71569 20.5903 6.09202 20.782C6.51984 21 7.0799 21 8.2 21H15.8C16.9201 21 17.4802 21 17.908 20.782C18.2843 20.5903 18.5903 20.2843 18.782 19.908C19 19.4802 19 18.9201 19 17.8V9M13 3L19 9M13 3V7.4C13 7.96005 13 8.24008 13.109 8.45399C13.2049 8.64215 13.3578 8.79513 13.546 8.89101C13.7599 9 14.0399 9 14.6 9H19"
      stroke="#363433"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>

  <svg v-if="props.typeOfIcon === 'document' && large" class="icon-large" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      id="file-large_black"
      d="M22.5 42.5H37.5M22.5 32.5H37.5M22.5 22.5H25M32.5 7.5H20.5C17.6997 7.5 16.2996 7.5 15.23 8.04497C14.2892 8.52433 13.5243 9.28924 13.045 10.23C12.5 11.2996 12.5 12.6997 12.5 15.5V44.5C12.5 47.3003 12.5 48.7004 13.045 49.77C13.5243 50.7108 14.2892 51.4757 15.23 51.955C16.2996 52.5 17.6997 52.5 20.5 52.5H39.5C42.3003 52.5 43.7004 52.5 44.77 51.955C45.7108 51.4757 46.4757 50.7108 46.955 49.77C47.5 48.7004 47.5 47.3003 47.5 44.5V22.5M32.5 7.5L47.5 22.5M32.5 7.5V18.5C32.5 19.9001 32.5 20.6002 32.7725 21.135C33.0122 21.6054 33.3946 21.9878 33.865 22.2275C34.3998 22.5 35.0999 22.5 36.5 22.5H47.5"
      stroke="#363433"
      stroke-width="4"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>

  <!-- Battery icon -->
  <svg v-if="props.typeOfIcon === 'battery' && !large" class="icon-small" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="battery-small_black">
      <path
        d="M21 13V11M6.2 18H16.8C17.9201 18 18.4802 18 18.908 17.782C19.2843 17.5903 19.5903 17.2843 19.782 16.908C20 16.4802 20 15.9201 20 14.8V9.2C20 8.0799 20 7.51984 19.782 7.09202C19.5903 6.71569 19.2843 6.40973 18.908 6.21799C18.4802 6 17.9201 6 16.8 6H6.2C5.0799 6 4.51984 6 4.09202 6.21799C3.71569 6.40973 3.40973 6.71569 3.21799 7.09202C3 7.51984 3 8.07989 3 9.2V14.8C3 15.9201 3 16.4802 3.21799 16.908C3.40973 17.2843 3.71569 17.5903 4.09202 17.782C4.51984 18 5.07989 18 6.2 18Z"
        stroke="#363433"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path d="M15.8261 10V13.6522M14 11.8261H17.6522" stroke="#363433" stroke-width="1.21739" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M5.5 12H9.15217" stroke="#363433" stroke-width="1.21739" stroke-linecap="round" stroke-linejoin="round" />
    </g>
  </svg>

  <svg v-if="props.typeOfIcon === 'battery' && large" class="icon-large" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="battery-large_black">
      <path
        d="M52.5 32.5V27.5M15.5 45H42C44.8003 45 46.2004 45 47.27 44.455C48.2108 43.9757 48.9757 43.2108 49.455 42.27C50 41.2004 50 39.8003 50 37V23C50 20.1997 50 18.7996 49.455 17.73C48.9757 16.7892 48.2108 16.0243 47.27 15.545C46.2004 15 44.8003 15 42 15H15.5C12.6997 15 11.2996 15 10.23 15.545C9.28924 16.0243 8.52433 16.7892 8.04497 17.73C7.5 18.7996 7.5 20.1997 7.5 23V37C7.5 39.8003 7.5 41.2004 8.04497 42.27C8.52433 43.2108 9.28924 43.9757 10.23 44.455C11.2996 45 12.6997 45 15.5 45Z"
        stroke="#363433"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path d="M39.5652 25V34.1304M35 29.5652H44.1304" stroke="#363433" stroke-width="3.04348" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M13.75 30H22.8804" stroke="#363433" stroke-width="3.04348" stroke-linecap="round" stroke-linejoin="round" />
    </g>
  </svg>

  <!-- Tool icon -->
  <svg v-if="props.typeOfIcon === 'monkey-wrench' && !large" class="icon-small" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.2148 12.7852L16.939 18.5094C17.4104 18.9809 17.6462 19.2166 17.8905 19.3324C18.1053 19.4343 18.3243 19.473 18.5158 19.4428C18.7336 19.4085 18.8987 19.2435 19.2287 18.9135L19.7001 18.4421C20.0301 18.1121 20.1951 17.9471 20.2294 17.7293C20.2596 17.5377 20.2209 17.3188 20.119 17.1039C20.0032 16.8596 19.7675 16.6238 19.296 16.1524L13.5718 10.4282"
      stroke="#363433"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M7.44357 2.41421C7.44357 2.41421 10.6256 2.76777 12.0987 4.24091C14.1611 6.3033 14.5648 9.4351 12.3933 11.6066C10.2218 13.7782 7.18565 13.47 4.9687 11.253C3.49556 9.77991 3.20093 6.65685 3.20093 6.65685"
      stroke="#363433"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M7.44342 2.41431C7.44342 2.41431 8.36889 3.33953 8.86876 3.83965C9.78449 4.75583 10.1757 7.03271 8.95431 8.2541C7.81868 9.38973 5.67565 9.13182 4.62616 8.08225C3.57667 7.03268 3.20095 6.65712 3.20095 6.65712"
      stroke="#363433"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <rect width="1.66667" height="4.33" transform="matrix(-0.707107 0.707107 0.707107 0.707107 11.2146 9.24976)" fill="white" />
  </svg>

  <svg v-if="props.typeOfIcon === 'monkey-wrench' && large" class="icon-large" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M26.9016 32.5784L41.2121 46.8889C42.3907 48.0675 42.98 48.6568 43.5907 48.9465C44.128 49.2012 44.6753 49.2978 45.1542 49.2224C45.6987 49.1366 46.1112 48.7241 46.9363 47.8991L48.1148 46.7205C48.9398 45.8955 49.3523 45.483 49.4381 44.9385C49.5135 44.4595 49.4169 43.9122 49.1622 43.375C48.8726 42.7643 48.2832 42.175 47.1046 40.9963L32.7941 26.6859"
      stroke="#363433"
      stroke-width="4"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M17.3261 6.79808C17.3261 6.79808 25.4283 7.53465 29.1112 11.2175C34.2672 16.3735 35.2765 24.203 29.8477 29.6318C24.4189 35.0606 17.3261 36.2609 10.6969 29.6317C7.01409 25.9489 6.27752 17.8466 6.27752 17.8466"
      stroke="#363433"
      stroke-width="4"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M17.3251 6.7992C17.3251 6.7992 21.0087 9.0081 23.2169 12.6924C25.1477 15.9139 25.4282 19.32 22.3748 22.3735C19.5357 25.2125 16.3636 26.5352 12.1687 23.7407C7.97384 20.9461 6.27617 17.8481 6.27617 17.8481"
      stroke="#363433"
      stroke-width="4"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <rect width="4.32758" height="10.825" transform="matrix(-0.707107 0.707107 0.707107 0.707107 26.959 23.6816)" fill="white" />
  </svg>

  <!-- Search icon -->
  <svg v-if="props.typeOfIcon === 'search'" class="icon-search" v-bind="$attrs" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.8554 9.524C9.97207 10.548 8.66793 11.2 7.21229 11.2C4.55993 11.2 2.40293 9.0464 2.40293 6.4C2.40293 3.7528 4.55993 1.6 7.21229 1.6C9.86386 1.6 12.0209 3.7528 12.0209 6.4C12.0209 7.132 11.8509 7.8232 11.5568 8.444L13.0052 9.1264C13.3995 8.2984 13.624 7.376 13.624 6.4C13.624 2.8712 10.7472 0 7.21229 0C3.67581 0 0.799805 2.8712 0.799805 6.4C0.799805 9.9288 3.67581 12.8 7.21229 12.8C8.40982 12.8 9.528 12.4648 10.4875 11.8912L14.6043 16L15.9998 14.6072L10.8554 9.524Z"
      fill="#2C2827" />
  </svg>

  <!-- Login icon -->
  <svg v-if="props.typeOfIcon === 'login'" class="icon-login" v-bind="$attrs" xmlns="http://www.w3.org/2000/svg" width="56" height="56" fill="none" viewBox="0 0 56 56">
    <path fill="#363433" d="M5.495 53.2C8.635 46.648 17.533 42.112 28 42.112c10.467 0 19.364 4.788 22.505 11.088H56c-3.14-9.324-14.392-16.128-28-16.128-13.607 0-24.86 6.804-28 16.128h5.495Z" />
    <path
      fill="#363433"
      d="M27.215 2.8C17.01 2.8 8.897 10.612 8.897 20.44c0 7.812 5.496 14.616 12.823 16.884l1.57-4.788c-5.234-1.512-9.159-6.3-9.159-12.096 0-7.056 5.757-12.6 13.084-12.6S40.3 13.384 40.3 20.44c0 5.544-3.663 10.08-8.635 11.844l1.832 4.788C40.56 34.552 45.533 28 45.533 20.44c0-9.828-8.374-17.64-18.318-17.64Z" />
  </svg>

  <!-- User icon -->
  <svg v-if="props.typeOfIcon === 'user'" class="icon-user" width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.49533 53.2002C8.63551 46.6482 17.5327 42.1123 28 42.1123C38.4673 42.1123 47.3645 46.9002 50.5047 53.2002H56C52.8598 43.8762 41.6075 37.0723 28 37.0723C14.3925 37.0723 3.14019 43.8762 0 53.2002H5.49533Z" fill="#363433" />
    <path
      d="M27.2152 2.80005C17.0096 2.80005 8.89746 10.612 8.89746 20.44C8.89746 28.252 14.3928 35.056 21.7199 37.324L23.29 32.536C18.0563 31.024 14.1311 26.236 14.1311 20.44C14.1311 13.384 19.8881 7.84004 27.2152 7.84004C34.5423 7.84004 40.2993 13.384 40.2993 20.44C40.2993 25.984 36.6358 30.52 31.6638 32.284L33.4956 37.072C40.561 34.552 45.533 28 45.533 20.44C45.533 10.612 37.1591 2.80005 27.2152 2.80005Z"
      fill="#363433" />
  </svg>
</template>

<script setup>
import { defineProps } from 'vue'

const props = defineProps({
  typeOfIcon: {
    type: String,
    default: () => '',
    validator: function (value) {
      const allowedValues = ['power-plug', 'document', 'battery', 'monkey-wrench', 'search', 'login', 'user']
      return allowedValues.includes(value)
    }
  },
  large: {
    type: Boolean,
    default: false
  }
})
</script>

<style scoped>
.icon-small {
  width: 1.5rem;
  height: 1.5rem;
}
.icon-large {
  width: 6rem;
  height: 6rem;
}

.icon-search {
  width: 1rem;
  height: 1rem;
}

.icon-login {
  width: 3.5rem;
  height: 3.5rem;
}

.icon-user {
  width: 3.5rem;
  height: 3.5rem;
}
</style>
